import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import BookingsDashboard from './pages/BookingsDashboard';
import './App.css';
import { Toaster } from 'react-hot-toast';
import Login from './pages/Login';
import ProtectedRoute from './components/ProtectedRoute';

function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route element={<ProtectedRoute />}>
            <Route path="/" element={<BookingsDashboard />} />
          </Route>
        </Routes>
      </div>
      <Toaster />
    </Router>
  );
}

export default App;

